import GetShopArticlePriceRequestModelBase from '../_generated/modelBases/get-shop-article-price-request-model-base';

export default class GetShopArticlePriceRequestModel extends GetShopArticlePriceRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
